<template>
  <b-form-group
    label="Şube Kodu"
    label-for="branch_code"
  >
    <b-form-input
      id="branch_code"
      v-model="dataItem.branch_code"
      placeholder="Şube Kodu"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'BranchCode',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['bankAccounts/dataItem']
    },
  },
}
</script>
